/**
 * Utility functions for URL sanitization and handling.
 */

/**
 * Ensures that a URL string starts with a valid protocol (http or https).
 * If not present, prefixes the URL with https://.
 * 
 * @param {string} url The URL to sanitize
 * @returns {string} The sanitized absolute URL
 */
export const ensureAbsoluteUrl = (url) => {
  if (!url) return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
};
